export default __webpack_public_path__ + "static/img-paper-3ac67c5e585eef4fb08dd4dea64c1c0e.png";